module.exports = __webpack_public_path__ + "img/2.b408eb5d.png";